import React, { useState, useEffect } from "react";
import { Typography, Checkbox, Chip } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";

const { portValidator } = require("port-validator");
const VerificationForm = (props) => {
  const {
    header_id,
    header_name,
    tags,
    setdatacheck,
    setAssignuserdata,
    assignuserdata,
    selected,
    itemselected,
    setSelected,
    backup,
  } = props;

  const [tempselected, setTempselected] = React.useState([]);

  const [userdata, setUserdata] = React.useState([]);

  const [newstate, setNewstate] = React.useState([]);
  const [verified, setVerified] = React.useState(false);
  const [ismulti, setIsmulti] = React.useState(false);

  const handleChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setNewstate((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    setAssignuserdata((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setIsmulti(!ismulti);
    setVerified(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const GroupSubmit = (selected) => (e) => {
    e.preventDefault();
    if (userdata !== undefined) {
      userdata.map((userdata) => {
        userdata.results.map((row) => {
          setdatacheck((prevState) => ({
            ...prevState,
            [row.cis_no]: true,
          }));
        });
      });
    }
    setdatacheck((prevState) => ({
      ...prevState,
      [header_id]: true,
    }));
    setOpen(false);
    var value1 = JSON.stringify(assignuserdata);
    window.sessionStorage.setItem("access_userdata", "checked");
    var backupdata;
    if (backup === "no") {
      backupdata = window.sessionStorage.getItem("backup");
    } else {
      backupdata = backup;
    }
    let sub = {
      temp_id: window.sessionStorage.getItem("TempID").toString(),
      taglist: selected.toString(),
    };

    const temp_id = window.sessionStorage.getItem("TempID");
    fetch(`${process.env.REACT_APP_API_URL}/api/run_temp/${temp_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(sub),
    })
      .then((response) => response.json())
      .then((data) => {
        window.localStorage.setItem("remedy_run_limit", data.detail);
        window.sessionStorage.setItem("access_userdata", "notchecked");
        window.sessionStorage.removeItem("userdata");
      })
      .catch((error) => {
        console.log(error);
        window.sessionStorage.setItem("access_userdata", "notchecked");
        window.sessionStorage.removeItem("userdata");
      });
  };

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const [oldselected, setOldselected] = React.useState([]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      let newSelected = [];
      newSelected = newSelected.concat(selected, tags);
      setOldselected(newSelected);
      setSelected(newSelected);
      setTempselected(tags);
      return null;
    }

    tags.map((row) => {
      var index = oldselected.indexOf(row);
      if (index !== -1) {
        oldselected.splice(index, 1);
        setSelected(selected);
      }
    });
    setTempselected([]);
    return null;
  };

  const [checkbackup, setCheckbackup] = useState(false);

  const [popovercheck, setPopovercheck] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event, name, number) => {
    setPopovercheck(number);
    sessionStorage.setItem("hintValue", name);
    setAnchorEl(event.currentTarget);
  };

  const oneClose = () => {
    setAnchorEl(null);
  };

  const two = Boolean(anchorEl);
  const id = two ? "simple-popover" : undefined;

  return (
    <>
      <Chip
        icon={
          <React.Fragment>
            <Checkbox
              indeterminate={
                tempselected.length > 0 && tempselected.length < tags.length
              }
              checked={tags.length > 0 && tempselected.length === tags.length}
              onChange={handleSelectAllClick}
              inputProps={{ "aria-label": "select all desserts" }}
              title="select all"
            />
          </React.Fragment>
        }
        label={
          <Typography fontWeight="fontWeightBold" variant="h7">
            <strong>Select all</strong>
          </Typography>
        }
        variant="outlined"
      />
      <DialogActions>
        <button
          className="font-bold outline uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none "
          type="button"
          onClick={handleClose}
        >
          Cancel
        </button>
        <button
          disabled={databackup ? false : true}
          className={
            databackup
              ? "bg-red-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              : "bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          }
          type="button"
          onClick={GroupSubmit(failedtags)}
        >
          Save
        </button>
      </DialogActions>
    </>
  );
};

export default VerificationForm;